import WildAppResource from "./WildAppResource";

export const PAY_NOW = 11010;
export const PAY_AT_CLOSE = 11020;
export const BILLED_SEPARATELY = 11030;
export const NO_COST = 11040;

export const ALL = {
    PAY_NOW,
    PAY_AT_CLOSE,
    BILLED_SEPARATELY,
    NO_COST,
};

class LuOrderPaymentTermAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-order-payment-term';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/orders/payments/terms';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }
}

export default LuOrderPaymentTermAppResource;
